import { type FC } from "react";

import type { DealerChangeLogItemEntity } from "src/app/features/DealerChangeLog/types/DealerChangeLogItemEntity";
import { type ExtendedColumnsType, type ResourceTableProps } from "../../../../../components";
import { PropertyTable } from "../../../../../components/Table/components/PropertyTable";
import { displayDateTimeValue } from "../../../../../components/Table/components/PropertyTable/transformations/cellTransformations";

const getColumnsConfig = (t: Function): ExtendedColumnsType<DealerChangeLogItemEntity>[] => {
    return [
        {
            title: t("dealerChangeLogDetailTable.from"),
            key: "from",
            dataIndex: "from",
        },
        {
            title: t("dealerChangeLogDetailTable.to"),
            key: "to",
            dataIndex: "to",
        },
        {
            title: t("dealerChangeLogDetailTable.state"),
            key: "state",
            dataIndex: "state",
        },
        {
            title: t("dealerChangeLogDetailTable.change"),
            key: "changed",
            dataIndex: "changed",
            render: (value) => displayDateTimeValue(value),
        },
    ];
};

export const DealerChangeLogItemTable: FC<ResourceTableProps<DealerChangeLogItemEntity>> = ({ datasource }) => {
    return (
        <PropertyTable<DealerChangeLogItemEntity>
            name="dealerChangeLogItems_table"
            getColumnsConfig={getColumnsConfig}
            propertyAsRowKey="id"
            tableData={datasource?.data ?? []}
            readOnly={false}
            rowsAreSelectable={false}
        />
    );
};
